import ApexCharts from "apexcharts";
window.ApexCharts = ApexCharts;
// Based on https://www.npmjs.com/package/svelte-apexcharts
export const chart = (node, options) => {
    let myChart = new ApexCharts(node, options);
    myChart.render();
    return {
        update(options) {
            myChart.updateOptions(options.update);
        },
        destroy() {
            myChart.destroy();
        },
    };
};
